function Slider2(container){
	var _this = this;
	this.container = $(container);
	_this.container.flexslider({
		pauseOnHover: true,
		animation: "slide",
		animationLoop: true,
		animationLoop: true,
		itemMargin: 0,
		move: 1,
		useCSS: false,
		controlNav: true,
		directionNav: false,
		startAt: 0,
		slideshow: false,
		slideshowSpeed: 5000,
		start: function() {
			var rel = $('.why-we-slider li.flex-active-slide').attr('rel');

			$('#' + rel).fadeIn();
			$('.why-we-slider #' + rel).fadeIn();
		},
		before: function() {
			$('.why-we-slider li').each(function(){
				$('.why-we-slider #' + $(this).attr('rel')).fadeOut();
			});
			$('.we-slider-img div').fadeOut();
		},
		after: function() {
			var rel = $('.why-we-slider li.flex-active-slide').attr('rel');
			$('#' + rel).fadeIn(1000);
			$('.why-we-slider #' + rel).fadeIn(1000);
		}
	});
}

if (typeof define === "function" && define.amd) {
	define('Controls/Slider2',['flexslider'], function() {
		return Slider2;
	});
};
